import { v4 as uuidv4 } from "uuid";

export const blogs = [
  {
    id: uuidv4(),
    title: "Tabs for a Portfolio Page in React",
    intro:
      "Tabs are a great choice to display different categories of a dataset. The user can click on various buttons to change the content. In this short post, I will be showing you how to make a Tabs Component in React JS.",
    link: "https://mitulgarg.medium.com/creating-tabs-for-a-portfolio-page-in-react-ba0f443fb868",
  },
  {
    id: uuidv4(),
    title: "FAQ Page using Javascript",
    intro:
      "The word FAQ stands for Frequently Asked Questions. A FAQ page answers the common questions that tend to recur. Every Business or Product website comes with a FAQ page with a list of questions people have asked about the specific service or product.",
    link: "https://mitulgarg.medium.com/faq-page-using-javascript-d74509f989d3",
  },
];
